import src from "IMAGE";
export default { src, width: 1128, height: 360, blurWidth: 0, blurHeight: 0};
